// src/context/UserContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [clientProfile, setClientProfile] = useState(null);

  useEffect(() => {
    const unsubscribe = getAuth().onAuthStateChanged(async (user) => {
      if (user?.email) {
        const q = query(
          collection(db, 'clients'),
          where('email', '==', user.email.toLowerCase())
        );
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          const docSnap = snapshot.docs[0];
          const profile = { id: docSnap.id, ...docSnap.data() };
          console.log('🧠 Perfil cargado en contexto:', profile);
          setClientProfile(profile);
        }
      }
    });

    return () => unsubscribe(); // cleanup
  }, []);

  return (
    <UserContext.Provider value={{ clientProfile, setClientProfile }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
